import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {ReportService} from '../service/report.service';
import {TaskService} from '../service/task.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, BaseResponse, Project, ProjectResponse, ReportsConfigResponse, ReportConfig, UserInfo, Task} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';

import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [TaskService],
})
export class ReportsComponent extends BaseComponent implements OnInit {
  userContext: UserContext;
  userInfo: UserInfo;
  it: any = AppConstants.ITA_CALENDAR_CONF;
  fromDate: Date = null;
  toDate: Date = null;
  reportsList: SelectItem[] = [];
  reportSelected: number;
  fileName: string = null;
  months: SelectItem[] = [];
  monthSelected: number = 0;
  projects: SelectItem[] = [];
  projectsSelected: string[] = [];
  extractClosedIssuesNotOlderThanDays = 35;
  selectedGruppo: number=0;
  filterUsers: SelectItem[] = [];
  gruppiUsers: SelectItem[] = [];
  gruppi: SelectItem[]=[];
  
  filterUsernames: SelectItem[] = [];
  managedUsers: SelectItem[] = [];
  numgruppi: number = null;
  utentiVisibili: SelectItem[]=[];
  onlyActive: boolean = true;
  users: SelectItem[] = [];
  usersFiltered: SelectItem[] = [];
  usersSelected: SelectItem[] = [];
  usersGroupFilter = false;

  forceReloadFilterTask = false;
  tasksFiltered: SelectItem[] = [];
  tasksSelected: SelectItem[] = [];
  reportsConfig: ReportConfig[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService,
    private reportService: ReportService,
    private taskService: TaskService,
    private busyProvider: BusyProvider,
    private datePipe: DatePipe) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {

      this.months.push({label: 'Gennaio', value: 0});
      this.months.push({label: 'Febbraio', value: 1});
      this.months.push({label: 'Marzo', value: 2});
      this.months.push({label: 'Aprile', value: 3});
      this.months.push({label: 'Maggio', value: 4});
      this.months.push({label: 'Giugno', value: 5});
      this.months.push({label: 'Luglio', value: 6});
      this.months.push({label: 'Agosto', value: 7});
      this.months.push({label: 'Settembre', value: 8});
      this.months.push({label: 'Ottobre', value: 9});
      this.months.push({label: 'Novembre', value: 10});
      this.months.push({label: 'Dicembre', value: 11});

      this.fromDate = new Date();
      this.fromDate.setDate(1); // primo del mese
      this.toDate = new Date(); // fine del mese
      this.toDate.setMonth(this.toDate.getMonth() + 1);
      this.toDate.setDate(0);
      this.monthSelected = this.fromDate.getMonth();

      this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
        result => {
          this.userInfo = result;
          if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
            this.userInfo.managedUsers.push(this.userContext.userId);
          }
        },
        error => {
          this.handleError(error);
        }
      );

      this.reportService.getConfig(this.userContext.srmToken).subscribe(
        response1 => {
          const configResponse: ReportsConfigResponse = response1;
          this.reportsConfig = configResponse.reports;
          for (let i = 0; i < this.reportsConfig.length; i++) {
            const config: ReportConfig = this.reportsConfig[i];
            this.reportsList.push({label: config.desc, value: i});
          }
          this.reportSelected = this.reportsList[0].value;
        },
        error => {
          this.handleError(error);
        }
      );

      this.taskService.getUserProjects(this.userContext.srmToken).subscribe(
        response => {
          let projectResponse: ProjectResponse = response;
          for (let i = 0; i < projectResponse.userProjects.length; ++i) {
            let project: Project = projectResponse.userProjects[i];
            this.projects.push({label: project.name, value: project.id});
          }
        },
        error => {
          this.handleError(error);
        }
      );

      this.loadUsers();
    }
  }

  loadUsers() {
    this.users = [];
    this.filterUsernames = [];
    this.userService.getUsers(this.userContext.srmToken, this.onlyActive).subscribe(
      result => {
        result.users.forEach(current => {
          this.users.push({label: current.fullname, value: current.id});
          this.filterUsernames.push({label: current.username, value: current.id});
          this.filterUsers.push({label: current.fullname, value: current.id});
          this.gruppiUsers.push({ label: this.getGruppoUser(current.username), value: current.id});
          
        });
        this.gruppi=[];
        this.numgruppi=0;
        this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
        for (const key in this.userInfo.managedUsersMap) {
            this.numgruppi++;
            this.gruppi.push({ label: key, value: this.numgruppi });                        
        }

        for (var i = 0; i < this.filterUsers.length; i++) {
          if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase())))
             this.managedUsers.push(this.filterUsers[i]);
        }

        if (this.usersGroupFilter){
          this.selectedGruppo=0;
          this.filterUtentiGruppi();
        }
            
      },
      error => {
        this.handleError(error);
      }
    );
  }

  switchMonth() {
    this.fromDate = new Date();
    this.fromDate.setDate(1);
    this.fromDate.setMonth(this.monthSelected);
    this.toDate = new Date();
    this.toDate.setMonth(this.monthSelected + 1);
    this.toDate.setDate(0);
  }

  filterUser(event) {
    this.usersFiltered = AppConstants.filterSuggestions(this.users, event.query, item => [item.label]);
  }

  filterTask(event) {
    this.tasksFiltered = [];
    this.tasksFiltered.push({label: 'Caricamento in corso...', value: ''});
    var projectIds = '';
    if (this.projectsSelected.length > 0) {
      this.projectsSelected.forEach(projectId => {
        projectIds += ',' + projectId;
      });
    } else {
      this.projects.forEach(project => {
        projectIds += ',' + project.value;
      });
    }
    projectIds = projectIds.substring(1);
    this.taskService.searchTaskByProject(this.userContext.srmToken, event.query, projectIds, 20, this.forceReloadFilterTask).subscribe(
      result => {
        this.forceReloadFilterTask = false;
        this.tasksFiltered = [];
        result.issues.forEach(issue => {
          this.tasksFiltered.push({label: issue.issueNo + ' - ' + issue.title, value: issue.issueNo});
        });
      },
      error => {
        this.tasksFiltered = [];
        this.handleError(error);
      }
    );
  }

  hasFilter(filterName) {
    if (this.reportsConfig && this.reportsConfig[this.reportSelected]) {
      const pn = this.reportsConfig[this.reportSelected].paramNames;
      for (const p in pn) {
        if (filterName === pn[p]) {
          return true;
        }
      }
    }
    return false;
  }

  isFilterRequired(filterName) {
    if (this.reportsConfig && this.reportsConfig[this.reportSelected]) {
      const rp = this.reportsConfig[this.reportSelected].requiredParams;
      for (const p in rp) {
        if (filterName === rp[p]) {
          return true;
        }
      }
    }
    return false;
  }

  exportReport() {
    this.busyProvider.showBusyIndicator();
    this.messageProvider.clearAll();

    let projectsFilter = null;
    for (let project of this.projectsSelected) {
      if (projectsFilter == null) {
        projectsFilter = project;
      } else {
        projectsFilter += ',' + project;
      }
    }

    let usersFilter = null;
    for (let user of this.utentiVisibili) {
      if (usersFilter == null) {
        usersFilter = user.value;
      } else {
        usersFilter += ',' + user.value;
      }
    }

    let tasksFilter = null;
    for (let task of this.tasksSelected) {
      if (tasksFilter == null) {
        tasksFilter = task.value;
      } else {
        tasksFilter += ',' + task.value;
      }
    }

    const parameters = new Object();
    if (this.hasFilter('from')) {
      parameters['from'] = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    }
    if (this.hasFilter('to')) {
      parameters['to'] = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    }
    if (this.hasFilter('projects')) {
      parameters['projects'] = projectsFilter;
    }
    if (this.hasFilter('extractClosedIssuesNotOlderThanDays')) {
      parameters['extractClosedIssuesNotOlderThanDays'] = this.extractClosedIssuesNotOlderThanDays;
    }
    if (this.hasFilter('userIds')) {
      parameters['userIds'] = usersFilter;
    }
    if (this.hasFilter('taskIds')) {
      parameters['taskIds'] = tasksFilter;
    }

    let errorMsg = '';
    const pn = this.reportsConfig[this.reportSelected].paramNames;
    for (const p in pn) {
      if (this.isFilterRequired(pn[p]) && !parameters[pn[p]]) {
        errorMsg += pn[p] + ', ';
      }
    }
    if (errorMsg) {
      this.busyProvider.hideBusyIndicator();
      this.messageProvider.notifyError('I seguenti filtri sono obbligatori: ' + errorMsg.substring(0, errorMsg.length - 2));
      return;
    }

    this.reportService.exportReport(this.userContext.srmToken, this.reportsConfig[this.reportSelected].clazz, parameters).
      subscribe(
      data => {
        this.busyProvider.hideBusyIndicator();
        this.downloadFile(data);
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        // nei report ci si aspetta un blob pertanto gli eventuali errori in json
        // non vengono correttamente mappati, pertanto non si utilizza la funzione
        // generica handleError ma si visualizza l'errore così com'è.
        this.messageProvider.notifyError(error);
      });
  }

  downloadFile(data) {
    let blob = new Blob([data], {type: 'application/vnd.ms-excel'});
    let file = this.reportsConfig[this.reportSelected].desc + '_' + new Date().getTime();
    if (this.fileName != null && this.fileName.trim() !== '') {
      file = this.fileName;
    }
    FileSaver.saveAs(blob, file + '.xlsx');
  }

  applyUsersGroupFilter() {
    this.usersSelected = [];
    this.utentiVisibili=[];
    this.usersGroupFilter = !this.usersGroupFilter;
    if (this.usersGroupFilter) {
      for (let i = 0; i < this.filterUsernames.length; i++) {
        let item = this.filterUsernames[i];
        if (this.userInfo.managedUsers.indexOf(item.label.toLowerCase()) != -1) {
          for (let j = 0; j < this.users.length; j++) {
            if (item.value == this.users[j].value) {
              this.usersSelected.push(this.users[j]);
              break
            }
          }                
        }
      }
      this.selectedGruppo=0;
      this.filterUtentiGruppi();
    } else {
      this.utentiVisibili=[];
    }
  }

  getGruppo(id: number): string | null {
      const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
      if (gruppo) {
          return gruppo.label;
      }
      return null;
  }

  filterUtentiGruppi() {
        
    this.utentiVisibili = [];
    if (this.selectedGruppo==0) {
        this.utentiVisibili=this.managedUsers;
    } else {
      const usernames = this.userInfo.managedUsersMap[this.getGruppo(this.selectedGruppo)];  
      if (Array.isArray(usernames)) {
        for (let username of usernames) {
          const user = this.filterUsernames.find(u => 
              u.label.toLowerCase().includes(username.toLowerCase()) 
          );
          if (user) {
              let item=this.filterUsers.find(u => 
                  u.value == user.value)
              this.utentiVisibili.push({ label: item.label, value: item.value });
          }
        }
      }
    }
  }

  getGruppoUser(username: string): string | null {
    if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
    
    const managedUsersMap = this.userInfo.managedUsersMap;
    
    for (const key in managedUsersMap) {
        if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
            const value = managedUsersMap[key];
            if (Array.isArray(value) && value.some(v => v.toLowerCase() === username.toLowerCase())) {
                return key;
            }
        }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts